const FALLBACK_HIDDEN_COLUMNS = new Set(["RowId", "operation_data"]);

export const getQueryResultColumnKeys = (rows, metadata) => {
  if (Array.isArray(metadata) && metadata.length > 0) {
    return metadata
      .filter(
        (column) =>
          column?.visible !== false &&
          typeof column?.key === "string" &&
          column.key.length > 0 &&
          !FALLBACK_HIDDEN_COLUMNS.has(column.key),
      )
      .map((column) => column.key);
  }

  if (!Array.isArray(rows)) return [];

  return Array.from(
    rows.reduce((columns, row) => {
      Object.keys(row || {}).forEach((key) => {
        if (!FALLBACK_HIDDEN_COLUMNS.has(key)) columns.add(key);
      });
      return columns;
    }, new Set()),
  );
};

export const getQueryResultColumnLabels = (metadata) => {
  if (!Array.isArray(metadata)) return {};

  return metadata.reduce((labels, column) => {
    if (
      column?.visible !== false &&
      typeof column?.key === "string" &&
      column.key.length > 0 &&
      !FALLBACK_HIDDEN_COLUMNS.has(column.key)
    ) {
      labels[column.key] =
        typeof column.label === "string" && column.label.trim()
          ? column.label
          : column.key;
    }

    return labels;
  }, {});
};
